module.exports = __webpack_public_path__ + "img/overview5.fa144494.png";